<naas-alerts id="alert_content"></naas-alerts>
<section class="deep-link-column" aria-label="Deep link notebook selection">
  <naas-school-banner></naas-school-banner>

  <section
    class="support-box notebook-select deep-link-box"
    aria-labelledby="deep_link_heading"
    aria-describedby="deep_link_description">
    <h2 id="deep_link_heading">Select the notebook for this VLE link</h2>
    <p id="deep_link_description">
      Students who open this link will be sent straight to the selected notebook server instead of stopping at the
      Noteable launcher first.
    </p>

    <form [formGroup]="form" (ngSubmit)="configure()" aria-label="Notebook Server selector">
      <label for="containerSelect">
        <span class="field-label">Notebook</span>
        <select name="containerSelect" id="containerSelect" formControlName="select">
          <option *ngFor="let container of containers" [value]="container.id">
            {{ container.display_name }}
          </option>
        </select>
      </label>

      <div class="actions">
        <button id="configure-button" type="submit" class="launch-page-button" [disabled]="!form.get('select')?.value">
          Add to VLE
        </button>
      </div>
    </form>
  </section>
</section>
